import i18n from '@/i18n';
import { NavigationGuard } from 'vue-router';
import store from '../store';

const EMPLOYER_GUARD: NavigationGuard = async (to, from, next) => {
   if (to.query.employer_id || store.state.userInfo?.userInfo?.is_contact_user) return next();

   const employer_id = store.state.userInfo?.userInfo?.default_employer?.id;
   if (!employer_id) {
      notifyError({ title: i18n.global.t('employers.no-default-employer') });
      return next({
         path: '/error',
         query: {
            error_code: '400',
            error_title: i18n.global.t('errors.error'),
            error_message: i18n.global.t('employers.no-default-employer'),
            error_action: 'refresh',
         },
      });
   }
   return next({ ...to, query: { ...to.query, employer_id } });
};

export default EMPLOYER_GUARD;
